import React, { useEffect, useState } from "react";
import { Card, Typography, Progress } from "antd";
import useViewportWidth from "../../hooks/useViewportWidth";

const { Title, Text } = Typography;
// const { useToken } = theme;

const steps = [
  "Uploading resume",
  "Reading document structure",
  "Extracting personal information",
  "Analyzing experience",
  "Identifying skills",
  "Finalizing resume data"
];

export default function ResumeParsingLoader() {
  // const { token } = useToken();
  const [progress, setProgress] = useState(10);
  const [stepIndex, setStepIndex] = useState(0);
  const viewportWidth = useViewportWidth();
  const isCompact = viewportWidth <= 768;

  useEffect(() => {
    const interval = setInterval(() => {

      setProgress((p) => {
        if (p >= 95) return p;
        return p + Math.random() * 8;
      });

      setStepIndex((s) => {
        if (s >= steps.length - 1) return s;
        return s + 1;
      });

    }, 1200);

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background:
          "radial-gradient(circle at 18% 20%, rgba(56, 189, 248, 0.18), transparent 24%), radial-gradient(circle at 82% 12%, rgba(168, 85, 247, 0.18), transparent 22%), linear-gradient(180deg, #020617 0%, #0f172a 100%)",
        padding: 24,
      }}
    >
      <Card
        style={{
          width: isCompact ? "100%" : 520,
          maxWidth: 520,
          borderRadius: 24,
          textAlign: "center",
          background: "rgba(15, 23, 42, 0.78)",
          border: "1px solid rgba(148, 163, 184, 0.18)",
          boxShadow: "0 30px 80px rgba(2, 6, 23, 0.48)",
          backdropFilter: "blur(18px)",
          overflow: "hidden",
        }}
        bodyStyle={{ padding: isCompact ? 24 : 36 }}
      >
        <div
          style={{
            width: 72,
            height: 72,
            margin: "0 auto 22px",
            borderRadius: 20,
            background:
              "linear-gradient(135deg, rgba(56, 189, 248, 0.2), rgba(168, 85, 247, 0.24))",
            border: "1px solid rgba(125, 211, 252, 0.28)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "inset 0 1px 0 rgba(255,255,255,0.08)",
          }}
        >
          <div
            style={{
              width: 34,
              height: 34,
              borderRadius: "50%",
              background: "linear-gradient(135deg, #38bdf8, #8b5cf6)",
              boxShadow: "0 10px 24px rgba(56, 189, 248, 0.28)",
            }}
          />
        </div>

        <Title level={4} style={{ color: "#f8fafc", marginBottom: 8 }}>
          Analyzing Your Resume
        </Title>

        <Text style={{ color: "#94a3b8" }}>
          Our AI is extracting important details from your resume
        </Text>

        <div style={{ marginTop: 30 }}>
          <Progress
            percent={Math.floor(progress)}
            status="active"
            trailColor="rgba(148, 163, 184, 0.16)"
            format={(percent) => (
              <span style={{ color: "#f8fafc", fontWeight: 700 }}>
                {percent}%
              </span>
            )}
            strokeColor={{
              "0%": "#38bdf8",
              "100%": "#8b5cf6",
            }}
          />
        </div>

        <div
          style={{
            marginTop: 18,
            fontSize: 14,
            color: "#cbd5e1",
            fontWeight: 500,
          }}
        >
          {steps[stepIndex]}...
        </div>

        <div
          style={{
            marginTop: 22,
            fontSize: 12,
            color: "#64748b"
          }}
        >
          This usually takes 3–5 seconds
        </div>
      </Card>
    </div>
  );
}
